import { Component, inject } from '@angular/core';
import { LoadingService } from '../../core/services/loading.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-loader-component',
    imports: [AsyncPipe],
    templateUrl: './loader-component.component.html',
    styleUrl: './loader-component.component.scss'
})
export class LoaderComponentComponent {
  private readonly loader: LoadingService = inject(LoadingService);
  public readonly loading$ = this.loader.loading$;
}
